/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: AssetPreview.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/10 @ 1840
 * ---
 * Description:
 */

import { Button, Card, Intent }             from '@blueprintjs/core';
import { useCallback }                      from 'react';
import { mleDomainGqlClient }               from '../../../api/domain';
import {
  DELETE_IMAGE_BY_ID
}                                           from '../../../api/domain/mutations.gql';
import { currentThemeIsDark, withEllipsis } from '../../../common/utils';
import classNames                           from 'classnames';
import {
  DeletionConfirmPopver
}                                           from '../../common/overlay/DeletionConfirmPopver';
import { Tooltip2 }                         from '@blueprintjs/popover2';

interface Props {
  src: string;
  name: string;
  id: number;
  onDelete: (id: number) => void;
  onAddAsset: (id: number) => void;
}

export const AssetThumbnail = (props: Props) => {
  const handleDelete = useCallback(async () => {
    try {
      await mleDomainGqlClient.mutate({
        mutation: DELETE_IMAGE_BY_ID,
        variables: {
          id: props.id
        }
      });
    } finally {
      props.onDelete(props.id);
    }
  }, []);

  return (
    <Card
      className="p-0 cursor-pointer"
      onDoubleClick={ () => props.onAddAsset(props.id) }>
      <div className="flex flex-col justify-between h-full">
        <img className="h-32 rounded-t object-contain hover:object-scale-down"
             src={ props.src }/>
        <div className={ classNames('flex flex-row rounded-b', {
          'bg-bpdark-100': currentThemeIsDark(),
          'bg-bpgray-100': !currentThemeIsDark()
        }) }>
          <div
            className="p-1 rounded overflow-hidden text-xs text-white ml-1 mb-1 mt-1 w-9/12 text-ellipsis">
            { withEllipsis(props.name) }
          </div>
          <div
            className={ 'w-1/3 flex flex-row justify-end align-middle space-x-1 my-1 px-1' }>
            <Button
              icon="plus"
              small
              intent={ Intent.PRIMARY }
              onClick={ () => props.onAddAsset(props.id) }
            />
            <Button
              icon="trash"
              small
              minimal
              disabled
            />
          </div>
        </div>
      </div>
    </Card>
  );
};
